import { colorsVariables, strictObjectAccess } from '../../dependencies';

export const Colors = strictObjectAccess({
    RED: colorsVariables.primary,
    BLUE: colorsVariables.secondary,
});
